import { Box, Button } from '@mui/material'
import { TextFieldWithLabel } from '../../Components/TextField'
import ButtonGroup from '../../Components/Button/ButtonGroup'
import { CheckBoxWithLabel } from '../../Components/CheckBox'
import { sendGet } from '../../hooks/use-fetch'

export interface CareMangementSearchCriteria {
  caseloadStatus: CaseloadFilterOption
  childName: string
  showUnassigned: boolean
}

export enum CaseloadFilterOption {
  MyCaseload,
  OrganizationCaseload,
}

export function CareMangementSearchOptions (props: { current: CareMangementSearchCriteria, onChange: (newSearch: CareMangementSearchCriteria) => void }): JSX.Element {
  const statusOptions: Array<{ id: CaseloadFilterOption, name: string }> = [
    { id: CaseloadFilterOption.MyCaseload, name: 'My Caseload' },
    { id: CaseloadFilterOption.OrganizationCaseload, name: 'Organization Caseload' }
    // { id: CaseloadFilterOption.Unassigned, name: 'Unassigned' }
  ]

  const handleChange = (e: any): void => {
    props.onChange({ ...props.current, [e.target.name]: e.target.value })
  }
  const handleSelectionChange = (newVal: number): void => {
    if (newVal != null) { props.onChange({ ...props.current, caseloadStatus: newVal }) }
  }
  const unassignedChange = (newVal: boolean): void => {
    props.onChange({ ...props.current, showUnassigned: newVal })
  }
  const openReport = async (): Promise<void> => {
    let filter = 'OrganizationCaseload'
    if (props.current.caseloadStatus === CaseloadFilterOption.MyCaseload) {
      filter = 'MyCaseload'
    } else if (props.current.showUnassigned) {
      filter = 'UnassignedCaseload'
    }
    const { response, success } = await sendGet(`/CareManagement/CareManagementListReportURL?filter=${filter}`, {})
    if (success) {
      window.open(response, '_blank')?.focus()
    }
  }

  return (<Box sx={{ boxSizing: 'border-box', alignItems: 'center', p: '4px 0px', gap: '10px', display: 'flex', flexDirection: 'row' }}>
    <Box sx={{ flexBasis: '300px' }}>
      <TextFieldWithLabel
        label='Child Name'
        onChange={handleChange}
        name='childName'
        maxWidth='300px'
        value={props.current.childName}
        data-testid="name-search"
        placeHolder='Last or First Name'
      />
    </Box>
    <Box sx={{ paddingTop: '15px', paddingLeft: '5px' }}>
      <ButtonGroup
        value={props.current.caseloadStatus}
        options={statusOptions}
        setValue={handleSelectionChange}
      />
    </Box>
    {props.current.caseloadStatus === CaseloadFilterOption.OrganizationCaseload && <CheckBoxWithLabel label='Show Only Un-assigned' name={''} value={props.current.showUnassigned} setValue={unassignedChange} edge={'start'} />}
    <Box sx={{ marginLeft: 'auto' }}>
      <Button color='secondary' variant='contained' onClick={openReport}>Export</Button>
    </Box>
  </Box>
  )
}
